export const commaSeparatedStringPattern = /^$|^[^,]+(,[^,]+)*$/;
